import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CopyRight from "../../components/CopyRight";
import Session from "../../utility/session";
import GeneralSettings from "../../components/Settings/GeneralSettings";
import PaymentHistory from "../../components/Settings/PaymentHistory";
import Security from "../../components/Settings/Security";
import UploadHistory from "../../components/Settings/uploadHistory";

class Settings extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="right_col" role="main">
        <div className="page-title">
          <div className="title_left">
            <h3>My Account</h3>
          </div>

          <div className="title_right" />
        </div>

        <div className="clearfix" />

        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_title">
              <h2 class="float-left">Account Settings</h2>
                <ul className="nav navbar-right panel_toolbox">
                  <li />
                </ul>
                <div className="clearfix" />
              </div>
              <div className="x_content">
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div
                    className=""
                    role="tabpanel"
                    data-example-id="togglable-tabs"
                  >
                    <ul
                      id="myTab"
                      className="nav nav-tabs bar_tabs"
                      role="tablist"
                    >
                      <li role="presentation" className="active">
                        <a
                          href="#tab_content1"
                          id="home-tab"
                          role="tab"
                          data-toggle="tab"
                          aria-expanded="true"
                        >
                          General
                        </a>
                      </li>
                      <li role="presentation" className="">
                        <a
                          href="#tab_content2"
                          role="tab"
                          id="profile-tab"
                          data-toggle="tab"
                          aria-expanded="false"
                        >
                          Security
                        </a>
                      </li>
                      <li role="presentation" className="">
                        <a
                          href="#tab_content3"
                          role="tab"
                          id="profile-tab2"
                          data-toggle="tab"
                          aria-expanded="false"
                        >
                          Payment History
                        </a>
                      </li>
                      <li role="presentation" className="">
                        <a
                          href="#tab_content4"
                          role="tab"
                          id="profile-tab3"
                          data-toggle="tab"
                          aria-expanded="false"
                        >
                          Archived
                        </a>
                      </li>
                    </ul>

                    <div id="myTabContent" className="tab-content">
                      <GeneralSettings />
                      <Security />
                      <PaymentHistory />
                      <UploadHistory />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Settings);



// WEBPACK FOOTER //
// ./src/Containers/Settings/index.js